/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, put, takeLatest } from 'redux-saga/effects';

import { selectInitedStateful } from '../../common/sagas';

import * as T from '../actions';

export function* handleUpdateSession({ payload: { form, values } }) {
  const stateful = yield call(selectInitedStateful);
  let actionType;

  try {
    yield call([stateful, 'updateSession'], values);
    actionType = 'successActions';
  } catch (err) {
    actionType = 'errorActions';
  }

  for (let i = 0; i < form[actionType].length; i++) {
    yield put(form[actionType][i]);
  }
}

export default function* watchUpdateSession() {
  yield takeLatest(T.UPDATE_SESSION, handleUpdateSession);
}
